import React from 'react';

const GOLD = '#e6b422';
const GRAY = '#bdbdbd';

function StarGlyph({ mode, size }) {
  const fill = mode === 'empty' ? GRAY : GOLD;
  const fillOpacity = mode === 'empty' ? 0.35 : mode === 'half' ? 0.5 : 1;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill={fill}
        fillOpacity={fillOpacity}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      />
    </svg>
  );
}

/**
 * Matches Android ReviewsAdapter / ReviewFragment star rules (full, half at ≥0.5 remainder, empty).
 */
export function StarRating({ value = 0, size = 'md', className = '' }) {
  const n = Number(value);
  const safe = Number.isFinite(n) ? Math.min(5, Math.max(0, n)) : 0;
  const full = Math.floor(safe);
  const hasHalf = safe - full >= 0.5;
  const px = size === 'lg' ? 32 : size === 'sm' ? 16 : 22;
  const label = `${safe.toFixed(1)} out of 5 stars`;

  return (
    <div className={`star-rating star-rating--${size} ${className}`.trim()} role="img" aria-label={label}>
      {[0, 1, 2, 3, 4].map((i) => {
        let mode = 'empty';
        if (i < full) mode = 'full';
        else if (i === full && hasHalf) mode = 'half';
        return <StarGlyph key={i} mode={mode} size={px} />;
      })}
    </div>
  );
}
